enum MediaBreakpoints {
	xs = 576,
	sm = 768,
	md = 992,
	lg = 1200,
	xl = Infinity
}

export default MediaBreakpoints;
